module.exports = __webpack_public_path__ + "static/img/icon_ham.db73f9b5.svg";